import React from 'react';
import { useIntl } from 'react-intl';
import { Box } from '@amzn/awsui-components-react';

import messages from './ChatBot.messages';
import { showChatBotPromoBanner } from './utils';
import { ContainerOverride } from '../PolarisOverrides';
import { useEventContext } from '../../contexts';
import { dataTestId } from '../../constants/dataTestIdSelectors';

import './ChatBotPromoBanner.scss';

const Logo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="chatbot-promo-banner-img"
      fill="none"
      viewBox="0 0 12 12"
    >
      <g clipPath="url(#a)">
        <g fill="#7d5aed" clipPath="url(#b)">
          <path
            stroke="#7d5aed"
            strokeLinejoin="round"
            d="m6.5 1.5 1.414 3.586L11.5 6.5 7.914 7.914 6.5 11.5 5.086 7.914 1.5 6.5l3.586-1.414L6.5 1.5Z"
          />
          <path d="m2 0 .636 1.364L4 2l-1.364.636L2 4l-.636-1.364L0 2l1.364-.636L2 0Z" />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#7d5aed" d="M0 0h12v12H0z" />
        </clipPath>
        <clipPath id="b">
          <path fill="#7d5aed" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

const ChatBotPromoBanner = ({ blueprintName }) => {
  const { formatMessage } = useIntl();
  const { event } = useEventContext();

  if (
    !showChatBotPromoBanner({
      eventContext: event,
      blueprintName,
    })
  ) {
    return null;
  }

  return (
    <ContainerOverride
      className="ChatBotPromoBanner__container"
      data-testid={dataTestId['ai-chatbot-promobanner']}
    >
      <Box variant="h3">{formatMessage(messages.promoBannerHeader)}</Box>
      <Box variant="p" margin={{ bottom: 's' }}>
        {formatMessage(messages.promoBannerMessage)}
      </Box>
      <Logo />
    </ContainerOverride>
  );
};

export default ChatBotPromoBanner;
